// extracted by mini-css-extract-plugin
module.exports = {"logo":"adminSideBar_logo__1wl99","adminSideBar":"adminSideBar_adminSideBar___Yxl6","nav":"adminSideBar_nav__1jAQw","link":"adminSideBar_link__3-B0e"};